<template>
  <div class="input" :class="[isFilled ? 'filled' : '', error ? 'error' : '']">
    <label :for="inputId">{{ label }}</label>
    <input
      v-if="mask"
      :id="inputId"
      v-mask="mask"
      :type="type"
      :placeholder="error || label"
      :value="value"
      :required="required"
      :disabled="disabled"
      @input="updateValue"
      @change="update"
      @keyup="update"
      :maxlength="maxLength"
    />
    <input
      v-else
      :id="inputId"
      :type="type"
      :placeholder="error || label"
      :value="value"
      :required="required"
      :disabled="disabled"
      @input="updateValue"
      @change="update"
      @keyup="update"
      :maxlength="maxLength"
    />
  </div>
</template>

<script>
import { mask } from "vue-the-mask";

export default {
  directives: { mask },
  props: {
    id: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: "text",
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: [String, Number],
      default: null,
    },
    mask: {
      type: [String, Array],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    isFilled() {
      return this.isEmptyValue(this.value);
    },
    inputId() {
      return this.id ? this.id : this._uid;
    },
  },
  methods: {
    updateValue(e) {
      this.$emit("input", e.target.value);
    },
    isEmptyValue(val) {
      return val !== "" && val !== null;
    },
    update(e) {
      this.$emit("update", e);
    },
  },
};
</script>

<style lang="scss" scoped>
$screen_desktop: 1200px;
$screen_huge: 1200px;

$sixth_color: #ec8ab3;
$color_text: #383838;
$color_line: #e2e2e6;
$color_error: #f05b78;
$color_gray: #e2e2e6;
$color_gray_text: #929296;
$border_radius: 5px;

$form_input_height: 50px;

$bg_image: #f6f6f9 asset-url("hero-bg.png") repeat;

.input {
  display: flex;
  align-items: center;
  margin: 5px 0;
  position: relative;

  &.hidden {
    display: none;
  }

  &.input--error {
    background-color: $color_error;
    box-shadow: 0 0 0 2px $color_error;
    color: white;
    // border-radius: $border_radius;

    input,
    select {
      box-shadow: 0 0 0 1px $color_error;
      border-color: $color_error;
    }

    .hint {
      display: none;
    }

    .error {
      display: block;
      font-size: 13px;
      padding: 5px 12px;
    }
  }

  .hint {
    display: block;
    font-size: 11px;
    margin: 5px 8px 0;
    color: $color_gray_text;
  }

  input,
  select,
  label {
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
  }

  input,
  select {
    box-sizing: border-box;
    background-color: white;
    height: $form_input_height;
    line-height: normal;
    padding: 15px;
    width: 100%;
    // border-radius: $border_radius;
    border-width: 0;
    box-shadow: 0 0 0 1px $color_gray;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    &:focus {
      box-shadow: 0 0 0 2px #626266;
    }
  }

  label {
    opacity: 0;
    position: absolute;
    left: 15px;
    top: 22px;
    font-size: 15px;
    transform: translateY(-50%);
    height: 11px;
    line-height: 12px;
    margin: 0;
    padding: 0;
    background: 0 0;
  }

  &.filled,
  &.select {
    label {
      color: #454f5b;
      opacity: 1;
      font-size: 11px;
      top: 14px;
      z-index: 1;
    }
    input,
    select {
      padding-top: 18px;
      padding-bottom: 5px;
    }
  }
}

input,
label {
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.input {
  input[type="text"],
  input[type="email"],
  input[type="number"],
  select {
    &[disabled="disabled"] {
      background-color: #f2f2f6;
    }
  }
}

input[type="text"],
input[type="email"],
input[type="number"] {
  box-sizing: border-box;
  background-color: white;
  height: $form_input_height;
  line-height: normal;
  padding: 10px 15px;
  width: 100%;
  // border-radius: $border_radius;
  border-width: 0;
  box-shadow: 0 0 0 1px $color_gray;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  &:focus {
    box-shadow: 0 0 0 1px #626266;
  }
}

.error {
  color: #f08080;

  input {
    background-color: #fef0f0;
    border: 1px solid #f08080;

    &:focus {
      box-shadow: 0 0 0 1px #f08080;
    }
  }
}
</style>
